export default "__VITE_ASSET__CzMbT_Jv__"